module.exports = __webpack_public_path__ + "static/img/312_2x.3d12568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/312_2x.png
// module id = puYv
// module chunks = 1